import { BaseRepository } from './BaseRepository'

export class RegistrationFormValuesRepository extends BaseRepository {
    getFormValues = async () => {
        return await super
            .getHttpClientInstance()
            .get<any>(`/api/v2/get-registration-values`)
    }
}
